import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { FicStatusProvider } from "@/context/FicStatusContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";

import Landing from "@/pages/Landing";
import Commercialisti from "@/pages/Commercialisti";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import Docs from "@/pages/Docs";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import SupplierLanding from "@/pages/SupplierLanding";
import SdiPlayground from "@/pages/SdiPlayground";
import Dashboard from "@/pages/Dashboard";
import InvoiceList from "@/pages/InvoiceList";
import InvoiceReview from "@/pages/InvoiceReview";
import CompanyProfile from "@/pages/CompanyProfile";
import UploadInvoice from "@/pages/UploadInvoice";
import SuppliersDirectory from "@/pages/SuppliersDirectory";
import FicIntegration from "@/pages/FicIntegration";
import AccountLayout from "@/pages/account/AccountLayout";
import AccountProfile from "@/pages/account/AccountProfile";
import AccountPassword from "@/pages/account/AccountPassword";
import AccountCompanies from "@/pages/account/AccountCompanies";
import AccountReferral from "@/pages/account/AccountReferral";
import AccountReviews from "@/pages/account/AccountReviews";
import AccountCredits from "@/pages/account/AccountCredits";
import AccountBilling from "@/pages/account/AccountBilling";
import AdminPanel from "@/pages/AdminPanel";
import Terms from "@/pages/legal/Terms";
import Privacy from "@/pages/legal/Privacy";
import Cookies from "@/pages/legal/Cookies";
import Gdpr from "@/pages/legal/Gdpr";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import { Toaster } from "@/components/ui/sonner";
import CookieConsent from "@/components/CookieConsent";

function App() {
  return (
    <div className="App">
      <AuthProvider>
       <FicStatusProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/commercialisti" element={<Commercialisti />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/docs" element={<Docs />} />

            {/* Blog */}
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />

            {/* Landing SEO per fornitore */}
            <Route path="/autofattura/:slug" element={<SupplierLanding />} />

            {/* Legal pages */}
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/gdpr" element={<Gdpr />} />

            {/* Payment result pages (public — session_id in URL is verified server-side) */}
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />

            <Route
              path="/app/admin/*"
              element={
                <ProtectedRoute>
                  <AdminPanel />
                </ProtectedRoute>
              }
            />

            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="invoices" element={<InvoiceList />} />
              <Route path="invoices/:id" element={<InvoiceReview />} />
              <Route path="upload" element={<UploadInvoice />} />
              <Route path="suppliers" element={<SuppliersDirectory />} />
              <Route path="integrations" element={<FicIntegration />} />
              <Route path="sdi/playground" element={<SdiPlayground />} />
              <Route path="company" element={<CompanyProfile />} />
              <Route path="account" element={<AccountLayout />}>
                <Route index element={<AccountProfile />} />
                <Route path="credits" element={<AccountCredits />} />
                <Route path="billing" element={<AccountBilling />} />
                <Route path="password" element={<AccountPassword />} />
                <Route path="companies" element={<AccountCompanies />} />
                <Route path="referral" element={<AccountReferral />} />
                <Route path="reviews" element={<AccountReviews />} />
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster richColors position="top-right" />
          <CookieConsent />
        </BrowserRouter>
       </FicStatusProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
